webpackJsonp([213534597649335],{

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pill = function (_React$Component) {
	  _inherits(Pill, _React$Component);
	
	  function Pill() {
	    _classCallCheck(this, Pill);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Pill.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'pill' },
	      this.props.children
	    );
	  };
	
	  return Pill;
	}(_react2.default.Component);
	
	exports.default = Pill;
	module.exports = exports['default'];

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Menu = __webpack_require__(146);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Links = __webpack_require__(145);
	
	var _Links2 = _interopRequireDefault(_Links);
	
	__webpack_require__(466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SidebarHome = function (_React$Component) {
	  _inherits(SidebarHome, _React$Component);
	
	  function SidebarHome() {
	    _classCallCheck(this, SidebarHome);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SidebarHome.prototype.render = function render() {
	    var location = this.props.location;
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        author = _props$data$site$site.author,
	        subtitle = _props$data$site$site.subtitle,
	        copyright = _props$data$site$site.copyright,
	        menu = _props$data$site$site.menu;
	
	    /* eslint-disable jsx-a11y/img-redundant-alt */
	
	    var authorBlock = _react2.default.createElement(
	      'div',
	      { className: 'sidebar_home__author-block' },
	      _react2.default.createElement(
	        'p',
	        { className: 'sidebar_home__author-subtitle' },
	        subtitle
	      )
	    );
	    /* eslint-enable jsx-a11y/img-redundant-alt */
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'sidebar_home' },
	      _react2.default.createElement(
	        'div',
	        { className: 'sidebar_home__inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar_home__author' },
	          authorBlock
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Menu2.default, { data: menu }),
	          _react2.default.createElement(_Links2.default, { data: author }),
	          _react2.default.createElement(
	            'p',
	            { className: 'sidebar_home__copyright' },
	            copyright
	          )
	        )
	      )
	    );
	  };
	
	  return SidebarHome;
	}(_react2.default.Component);
	
	exports.default = SidebarHome;
	module.exports = exports['default'];

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(175);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _wordtree = __webpack_require__(581);
	
	var _wordtree2 = _interopRequireDefault(_wordtree);
	
	__webpack_require__(467);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Title = function (_React$Component) {
	  _inherits(Title, _React$Component);
	
	  function Title() {
	    _classCallCheck(this, Title);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Title.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      _react2.default.createElement('img', { src: _wordtree2.default }),
	      _react2.default.createElement(
	        'div',
	        { className: 'title__name' },
	        'WordTree Foundation'
	      )
	    );
	  };
	
	  return Title;
	}(_react2.default.Component);
	
	exports.default = Title;
	module.exports = exports['default'];

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wordtree.a1cbbaf6.png";

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Post = __webpack_require__(58);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(227);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Pill = __webpack_require__(223);
	
	var _Pill2 = _interopRequireDefault(_Pill);
	
	var _SidebarHome = __webpack_require__(225);
	
	var _SidebarHome2 = _interopRequireDefault(_SidebarHome);
	
	__webpack_require__(468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Header from '../components/Header';
	
	
	var IndexRoute = function (_React$Component) {
	  _inherits(IndexRoute, _React$Component);
	
	  function IndexRoute() {
	    _classCallCheck(this, IndexRoute);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexRoute.prototype.render = function render() {
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle;
	
	
	    var post = this.props.data.allMarkdownRemark.edges[0];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: subtitle })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: 25, marginBottom: 25 } },
	        _react2.default.createElement(_Title2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout' },
	        _react2.default.createElement(_SidebarHome2.default, this.props),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content__inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'index__articles' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'News'
	              ),
	              _react2.default.createElement(_Post2.default, { data: post, key: post.node.fields.slug }),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/news/' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'See All',
	                  ' ',
	                  _react2.default.createElement(
	                    _Pill2.default,
	                    null,
	                    this.props.data.allMarkdownRemark.edges.length
	                  ),
	                  ' ',
	                  'Articles'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'index__projects' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Projects'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.bookofmormonorigins.com' },
	                  'Book of Mormon Origins'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'An open-source, public domain resource that adds missing footnotes to the Book of Mormon.'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://wordtree.org/thelatewar' },
	                  'The Late War Study'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'A computer-aided study that reveals some remarkable similarities between the Book of Mormon and The Late War Between the United States and Great Britain (published in 1816).'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://github.com/wordtreefoundation/bomdb' },
	                  'BomDB (Book of Mormon Database)'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'A resource for computer-aided studies of the Book of Mormon. Contains a command-line tool (Linux/MacOS/Windows) that can be used to find specific verses across multiple editions, or produce full copies (with our without chapter/verse annotations) of each edition.'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return IndexRoute;
	}(_react2.default.Component);
	
	exports.default = IndexRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-802464d161a576a32a39.js